// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video":"css-1o3PE-Ybit","video_icon":"css-14yBqLC2IX","video_wrapper":"css-bL-T1Uk1ms","video_wrapper_src":"css-2ytBnv3vR7","video_caption":"css-hCdeQ3tv3x"};